var _defs, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudButTriangleWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50.1 50.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .triangle-cls-1 {\n        fill: none;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: 0.1px;\n        opacity: 0;\n      }\n\n      .triangle-cls-2 {\n        fill: currentColor;\n        stroke: none;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "triangle-cls-1",
    x: 0.05,
    y: 0.05,
    width: 50,
    height: 50
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "triangle-cls-2",
    d: "M43.86,20.11a4.69,4.69,0,0,1-1.43,3.4l-14,13.78a4.91,4.91,0,0,1-6.9,0l-14-13.77a4.76,4.76,0,0,1,0-6.8A4.88,4.88,0,0,1,11,15.3H39a4.83,4.83,0,0,1,3.45,1.42A4.68,4.68,0,0,1,43.86,20.11Z",
    transform: "translate(0.05 0.05)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudButTriangleWhite);
export default __webpack_public_path__ + "static/media/cloud_but_triangle_white.f52e92400353baad994ce77bff75d83f.svg";
export { ForwardRef as ReactComponent };